import { contentApi } from '../../infrastructure/Configuration'

export default class MembersBenefitService {
  constructor (httpClient) {
    this.httpClient = httpClient
  }

  getMembersBenefits = async () => {
    const url = `${contentApi}/room-display/members-benefits`
    const { data } = await this.httpClient.get(url)

    return data
  }
}
